import { createAsyncThunk } from '@reduxjs/toolkit';
import { CreateSiteResponse, SiteRequest } from '../../utils/Models';
import SitesService from '../../config/services/customer-services/sites-service';

export const submitSiteDetails = createAsyncThunk<
  CreateSiteResponse, 
  SiteRequest,        
  { rejectValue: string } 
>('site/create', async (payload, { rejectWithValue }) => {
  try {
    const response = await SitesService.createSite(payload);
    return response;
  } catch (error: any) {
    return rejectWithValue(error.response?.data ?? error.message);
  }
});
